import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { CurrentUser, UserService } from '@app/core/services/user.service';

export const authenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const userService = inject(UserService);

  return userService.fetchUser().then((user: CurrentUser | null) => {
    if (user) {
      return true;
    }

    userService.login(state.url);
    return false;
  });
};
